module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAWCAYAAAAb+hYkAAAABHNCSVQICAgIfAhkiAAAATBJREFUOE+d1MtKw0AUBuD/HxDiyvsruK4XBBNfQTRduBGa2Cdy585Y30G8VAQxqc/gXhBcKtSkixyZocqEZqrNLIfz5UxO/gmLNDoCeQbgU5HRnJ884o/FPIvfCayN64YluD8fJA/THIssfgGwbhUNRakDb/f83gU5GnR2RNQdgIUKhIRe0NP7E4t6Z1ZokIFpd1tY9gEsWo/+EjL0/OTWbveLDHyKtkRRwyWrKBci9PyLm5+9CpoCC5Ey9PYur3XNBDLw+WRTStEdl62OI4G0vaB3VYvGw9kQURquVKAgdCIDs7hVQvoEVy341gDJq/t4WdwSQKeiejxIu34Qg079+7gG4Zice+Qzf1xHjHIhD2tj5Ahsbe5MImZNuEGNLmGz655Gx0KcEvxQZPc/P5ZvfWK56I996FoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./images/testimonial-next2.png
// module id = 388
// module chunks = 1